import { v4 as uuidv4 } from 'uuid'

interface Props {
  [key: string]: any
  direction?: 'up' | 'down'
  isLastItem?: boolean
  fillColor?: string
  children?: React.ReactNode
}

function PointerContainer(props: Props): React.ReactElement {
  const { direction = 'down', fillColor = '#1E1B4B', children, isLastItem = false, ...rest } = props
  const uuid = uuidv4()

  const config = {
    down: {
      viewBox: '0 0 239 280',
      path: `
        M237.22 14.9998V236.079C237.22 241.282 233.002 245.5 227.799 245.5
        H150.314C148.37 245.5 146.538 246.406 145.359 247.951
        L124.064 275.849C121.57 279.117 116.65 279.117 114.155 275.849
        L92.861 247.951C91.682 246.406 89.85 245.5 87.906 245.5H10.421
        C5.218 245.5 1 241.282 1 236.079V14.9998
        C1 7.25982 7.27 0.999817 15 0.999817H223.22
        C230.95 0.999817 237.22 7.25982 237.22 14.9998Z
      `,
      gradient: {
        id: 'grad-down',
        x1: '1214.33',
        y1: '-592.658',
        x2: '1452.55',
        y2: '-592.658',
      },
    },

    up: {
      viewBox: '0 0 239 280',
      path: `
        M237.22 43.2208V268.879C237.22 274.082 233.002 278.3 227.799 278.3
        H10.421C5.218 278.3 1 274.082 1 268.879V43.2208
        C1 38.0178 5.218 33.7998 10.421 33.7998H90.417
        C92.36 33.7998 94.192 32.8938 95.371 31.3488
        L116.665 3.45081C119.16 0.182808 124.08 0.182808 126.575 3.45081
        L147.869 31.3488C149.048 32.8938 150.88 33.7998 152.824 33.7998
        H227.799C233.002 33.7998 237.22 38.0178 237.22 43.2208Z
      `,
      gradient: {
        id: 'grad-up',
        x1: '978.108',
        y1: '-172.947',
        x2: '1216.33',
        y2: '-172.947',
      },
    },
  }[direction]

  const clipId = `clip-${direction}-${uuid}`

  return (
    <svg viewBox={config.viewBox} xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d={config.path}
        fill={fillColor}
        stroke={`url(#${config.gradient.id}-${uuid})`}
        strokeLinejoin="round"
        strokeWidth="2"
      />

      <foreignObject clipPath={`url(#${clipId})`} height="100%" width="100%" x="0" y="0">
        <div
          style={{
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            boxSizing: 'border-box',
          }}
        >
          {children}
        </div>
      </foreignObject>

      <defs>
        <clipPath id={clipId}>
          <path d={config.path} />
        </clipPath>

        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={`${config.gradient.id}-${uuid}`}
          x1={config.gradient.x1}
          x2={config.gradient.x2}
          y1={config.gradient.y1}
          y2={config.gradient.y2}
        >
          <stop stopColor={isLastItem ? '#BA7547' : '#467AFF'} />
          <stop offset="0.0369048" stopColor={isLastItem ? '#BA7547' : '#467AFF'} />
          <stop offset="0.595238" stopColor={isLastItem ? '#BA7547' : '#FB0E97'} />
          <stop offset="0.977381" stopColor={isLastItem ? '#BA7547' : '#FF9B05'} />
          <stop offset="1" stopColor={isLastItem ? '#BA7547' : '#FF9B05'} />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default PointerContainer
